import { render, staticRenderFns } from "./SinglePeriod.vue?vue&type=template&id=aa6381c8&scoped=true"
import script from "./SinglePeriod.vue?vue&type=script&lang=ts"
export * from "./SinglePeriod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6381c8",
  null
  
)

export default component.exports